
(function () {
  function fixGoldenHomeStarsAndHeader() {
    var starSelectors = [
      '.ghStars',
      '.ghReviewStars',
      '.ghReviewRating',
      '.ghRating',
      '.review-stars',
      '.reviewStars',
      '.stars',
      '.star-rating',
      '.rating'
    ];

    starSelectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        el.style.overflow = 'visible';
        el.style.minHeight = '34px';
        el.style.height = '34px';
        el.style.lineHeight = '34px';
        el.style.color = '#f5a623';

        if (!el.getAttribute('data-gh-stars-fixed')) {
          el.setAttribute('data-gh-stars-fixed', 'true');
          el.setAttribute('aria-label', '5 out of 5 stars');
        }
      });
    });

    document.querySelectorAll('.ghReviewCard, .ghReview, .review-card, .testimonial-card').forEach(function (card) {
      card.style.overflow = 'visible';
      card.style.minHeight = '250px';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixGoldenHomeStarsAndHeader);
  } else {
    fixGoldenHomeStarsAndHeader();
  }

  window.addEventListener('resize', fixGoldenHomeStarsAndHeader);
  document.addEventListener('shopify:section:load', fixGoldenHomeStarsAndHeader);
})();
